import React from "react";
import { ListItem, Typography, Paper, List, Box } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { Link } from "react-router-dom";
import PageIntro from "../components/pageintro";

const servicesGridData = [
    {
      src: "/assets/BigData/DataLake/image1.png",
      alt: "why1",
      width: "350px",
      paddingTop: "6%",
      text: "Data Lake Strategy Consultation",
    },
    {
      src: "/assets/BigData/DataLake/image2.png",
      alt: "why1",
      width: "350px",
      paddingTop: "6%",
      text: "Data Lake Implementation With Integrated Analytics",
    },
    {
      src: "/assets/BigData/DataLake/image3.png",
      alt: "why1",
      width: "350px",
      paddingTop: "6%",
      text: "Deploying ML Models",
    },
    {
      src: "/assets/BigData/DataLake/image4.png",
      alt: "why1",
      width: "350px",
      paddingTop: "6%",
      text: "Cloud Migrations",
    },
  ];
  

const DataLake = () => {
  return (
    <Box sx={{ display: "flex", flexDirection: "column", overflow: "hidden" }}>
      <PageIntro
        bg={"/assets/BigData/DataLake/Banner.webp"}
        subheading={"Uncover Intelligent Insights with Tecloq’s"}
        heading={"Data Lake Services"}
        desc={"Dive Deeper, Decide Smarter"}
      />

      <Paper
        elevation={0}
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          margin: { xs: "5%", md: "8% 3% 5% 9%" },
          padding: "0 !important",
          height: "auto",
        }}
      >
        {/* Text Section */}
        <section sx={{ width: { xs: "100%", md: "120%" } }}>
          <Typography
            sx={{
              fontFamily: "Orbitron",
              fontWeight: "800",
              fontSize: { xs: "24px", sm: "32px", md: "40px" },
              color: "#000000",
              lineHeight: "120%",
              letterSpacing: "2%",
              display: "flex",
              justifyContent: { xs: "center", md: "flex-start" },
              paddingBottom: "8%",
              textAlign: { xs: "center", md: "left" },
            }}
          >
            Building Robust and Scalable Data Lakes for Your Business
          </Typography>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "normal",
              color: "#000000",
              fontSize: { xs: "14px", sm: "20px", md: "24px" },
              textAlign: { xs: "center", md: "left" },
              paddingX: { xs: "5%", md: "0" },
            }}
          >
            As data becomes the lifeblood of modern businesses, the emergence of
            enterprise data lakes has reshaped the landscape, offering a
            reservoir for raw information, ready to empower decision-making. Our
            Data Lake Consulting expertise goes beyond implementation - we
            specialize in extracting maximum value from your data lake:
          </Typography>

          {[
            {
              title: "Centralization:",
              content:
                "Break down content silos and harness the true potential of your data.",
            },
            {
              title: "Transformation:",
              content:
                "Overcome legacy system limitations, paving the way for modern analytics.",
            },
            {
              title: "Insight Enrichment:",
              content:
                "Unleash the possibilities by enriching data beyond source limitations.",
            },
          ].map((item, index) => (
            <Typography
              key={index}
              component="li"
              sx={{
                fontFamily: "Inter",
                fontWeight: "normal",
                color: "#000000",
                fontSize: { xs: "14px", sm: "20px", md: "24px" },
                marginLeft: { xs: "5%", md: "10%" },
                textIndent: { xs: "-1%", md: "-6%" },
                listStyle: "none",
                "&::before": {
                  content: "'• '",
                  fontWeight: "bold",
                },
              }}
            >
              <span style={{ fontWeight: "bold" }}>{item.title} </span>
              {item.content}
            </Typography>
          ))}

          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: "normal",
              color: "#000000",
              fontSize: { xs: "14px", sm: "20px", md: "24px" },
              marginTop: "5%",
              textAlign: { xs: "center", md: "left" },
              paddingX: { xs: "5%", md: "0" },
            }}
          >
            But the true potential lies in intelligent search and analytics.
            Experience the advantage, solve problems, and stay ahead. Unlock the
            true power of your data lake with Tecloq.
          </Typography>
        </section>

        {/* Image Section */}
        <section>
          <img
            src="/assets/BigData/DataLake/robust.png"
            alt="ourgoal"
            style={{
              height: "auto",
              width: "85%",
              margin: "15% 0 0 5%",
              display: "block",
            }}
            loading="lazy"
          />
        </section>
      </Paper>

      <Box
        sx={{
          maxWidth: "100% !important",
          height: "auto",
          marginTop: "3%",
          paddingX: { xs: "5%", sm: "10%", md: "0" }, // Responsive padding
        }}
      >
        <Typography
          sx={{
            fontFamily: "Orbitron",
            fontWeight: "800",
            fontSize: { xs: "24px", sm: "32px", md: "40px" },
            color: "#000000",
            lineHeight: "120%",
            letterSpacing: "2%",
            display: "flex",
            justifyContent: "center",
            paddingBottom: "1%",
            textAlign: "center", // Center align on all screens
          }}
        >
          Our Data Lake Services
        </Typography>

        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: "lighter",
            fontSize: { xs: "14px", sm: "18px", md: "20px" },
            color: "#000000",
            display: "flex",
            justifyContent: "center",
            margin: { xs: "2% 5%", sm: "2% 10%", md: "2% 15% 5%" }, // Adjust margin for different screens
            textAlign: "center",
          }}
        >
          Leverage the power of analytics and revolutionize the way you uncover
          insights with our exceptional Data Lake Solutions. At Tecloq, we are
          your trusted Data Lake Consultants, guiding you through a
          transformative journey that paves the way for a cutting-edge data lake
          ecosystem.
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '3%' }}>
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: {
        xs: 'repeat(1, 1fr)', // 1 column on small screens
        sm: 'repeat(2, 1fr)', // 2 columns on tablets
        md: 'repeat(2, 1fr)', // 2 columns on medium screens
        lg: 'repeat(2, 1fr)', // 2 columns on large screens
      },
      gap: { xs: '12px', sm: '20px', md: '40px' },
      placeItems: 'center', // Center cards properly on mobile view
      padding: '0 5%',
    }}
  >
    {[
      {
        src: '/assets/BigData/DataLake/image1.png',
        alt: 'why1',
        text: 'Data Lake Strategy <br /> Consultation',
      },
      {
        src: '/assets/BigData/DataLake/image2.png',
        alt: 'why2',
        text: 'Data Lake <br /> Implementation With <br /> Integrated Analytics',
      },
      {
        src: '/assets/BigData/DataLake/image3.png',
        alt: 'why3',
        text: 'Deploying ML Models',
      },
      {
        src: '/assets/BigData/DataLake/image4.png',
        alt: 'why4',
        text: 'Cloud Migrations',
      },
    ].map((item, index) => (
      <Paper
        key={index}
        elevation={3}
        sx={{
          borderRadius: '20px',
          width: { xs: '100%', sm: '90%', md: '420px', lg: '400px' },
          textAlign: 'center',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxShadow: '0px 0px 14.4px rgba(0, 0, 0, 0.25)',
          padding: { xs: '12px', sm: '16px', md: '20px' },
        }}
      >
        <img
          src={item.src}
          alt={item.alt}
          loading="lazy"
          style={{
            width: '100%',
            maxWidth: '280px',
            height: 'auto',
            padding: '5% 0',
          }}
        />
        <Typography
          sx={{
            fontFamily: 'Inter',
            fontSize: { xs: '16px', sm: '18px', md: '20px' },
            fontWeight: 'bold',
            color: '#000',
            letterSpacing: '1%',
            lineHeight: '120%',
            paddingTop: '8px',
          }}
          dangerouslySetInnerHTML={{ __html: item.text }}
        />
      </Paper>
    ))}
  </Box>
</Box>



<Box sx={{ maxWidth: "100%", height: "auto", marginTop: "7%" }}>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", sm: "32px", md: "40px" }, // Responsive font size
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: "1%",
    }}
  >
    The Process
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "300", // Use numeric value for consistency
      fontSize: { xs: "14px", sm: "16px", md: "20px" }, // Responsive font size
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      margin: { xs: "2% 5% 0%", sm: "1% 10% 0%" }, // Adjusted margins for different breakpoints
      textAlign: "center",
    }}
  >
    Experience the pinnacle of data management with Tecloq’s comprehensive
    data lake integration and implementation solutions.
  </Typography>
</Box>


<Box
  sx={{
    display: "flex",
    flexDirection: "column",
    maxWidth: "100%",
    height: "auto",
    alignItems: "center",
  }}
>
  <img
    src="/assets/BigData/DataLake/Process.gif"
    loading="lazy"
    alt="tech"
    style={{
      width: "100%", // Full width on smaller screens
      maxWidth: "600px", // Limits size on larger screens
      height: "auto",
      paddingTop: "0", // Removed invalid negative padding
    }}
  />
</Box>


      <Box>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: { xs: "3%", md: "5%" },
    }}
  >
    Related Capabilities
  </Typography>

  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      flexWrap: "wrap",
      gap: "20px",
      marginTop:{xs:"20px"}
    }}
  >
    {[
      {
        src: "/assets/BigData/DataLake/BD.png",
        title: "Big Data Solutions",
        text: "Uncover hidden insights from massive datasets with our cutting-edge big data solutions, empowering your business to make informed decisions at scale.",
      },
      {
        src: "/assets/BigData/DataLake/BI.png",
        title: "Business Intelligence",
        text: "Transform raw data into actionable insights and visualizations that drive strategic decision-making, using our business intelligence services to gain a competitive edge.",
      },
      {
        src: "/assets/BigData/DataLake/AI.png",
        title: "Artificial Intelligence",
        text: "Harness the power of artificial intelligence to drive innovation and automation in your processes, creating smarter systems and enhancing customer experiences with our AI solutions.",
      },
    ].map((item, index) => (
      <Paper
        key={index}
        elevation={3}
        sx={{
            borderRadius: "3%",
            textAlign: "center",
            border: "0.5px solid #FFC3EA",
            alignContent: "center",
            justifyContent: "center",
            boxShadow: "0px -3px 17px rgba(240, 5, 162, 0.52)",
            background:
            "linear-gradient(153.3deg, #FFFFFF 8.98%, #FFEAF8 89.37%)",
            display: "flex",
            flexDirection: "column",
            width: { xs: "60%", sm: "350px" }, // Responsive width
            height: { xs: "auto", md: "500px" }, // Adjust height on mobile
            padding: { xs: "5% 5%", sm: "0" },
            marginBottom: { xs: "5%" },
          }}
      >
        <img
          src={item.src}
          alt={item.title}
          loading="lazy"
          style={{
            width: "30%",
            height: "auto",
            margin: "0 auto",
            paddingTop: "10%",
          }}
        />
        <Typography
          sx={{
            fontFamily: "Orbitron",
            lineHeight: "120%",
            fontSize: { xs: "20px", md: "28px" },
            fontStyle: "normal",
            fontWeight: "700",
            color: "#F005A2",
            letterSpacing: "2%",
            marginTop: "10px",
          }}
        >
          {item.title}
        </Typography>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontStyle: "normal",
            lineHeight: "140%",
            fontSize: { xs: "14px", md: "16px" },
            padding: "10% 5%",
          }}
        >
          {item.text}
        </Typography>
      </Paper>
    ))}
  </Box>
</Box>

<Box
  sx={{
    maxWidth: "100%",
    height: "auto",
    marginTop: "3%",
    padding: "0 5%",
  }}
>
  <Typography
    sx={{
      fontFamily: "Orbitron",
      fontWeight: "800",
      fontSize: { xs: "24px", md: "40px" },
      color: "#000000",
      lineHeight: "120%",
      letterSpacing: "2%",
      display: "flex",
      justifyContent: "center",
      paddingBottom: { xs: "3%", md: "1%" },
      textAlign: "center",
    }}
  >
    The Tecloq Advantage
  </Typography>
  <Typography
    sx={{
      fontFamily: "Inter",
      fontWeight: "300",
      fontSize: { xs: "14px", md: "20px" },
      color: "#000000",
      display: "flex",
      justifyContent: "center",
      margin: { xs: "3% 0%", md: "1% 10% 0%" },
      textAlign: "center",
      lineHeight: "140%",
    }}
  >
    At Tecloq, we’re not just offering a service; we’re revolutionizing the way
    businesses harness data. Propel your growth, innovation, and success with
    our game-changing Data Lake Service.
  </Typography>
</Box>


<Box
  sx={{
    display: "flex",
    justifyContent: "center",
    flexWrap: "wrap",
    gap: "12px",
  }}
>
  {[
    {
      title: "Seasoned Professionals",
      text: `Unleash the true potential of data lake architecture with our adept 
            consultants. Drawing from their extensive experience, they're well-versed 
            in crafting and implementing robust data lake solutions tailored to your 
            industry's demands.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 23%" },
    },
    {
      title: "Strategic Project Management",
      text: `Incorporating Agile methodology, our Data Lake consulting services 
            streamline strategic planning and data lake deployment, enhancing 
            agility and efficiency throughout the process.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 14%" },
    },
    {
      title: "Insights from Latest Tools",
      text: `Position your business for data-driven triumphs. Our service equips you 
            with advanced analytics and insights, vital for informed, impactful 
            decisions that shape your industry trajectory.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 21%" },
    },
    {
      title: "Seasoned Professionals",
      text: `Unleash the true potential of data lake architecture with our adept 
            consultants. Drawing from their extensive experience, they're well-versed 
            in crafting and implementing robust data lake solutions tailored to your 
            industry's demands.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 23%" },
    },
    {
      title: "Strategic Project Management",
      text: `Incorporating Agile methodology, our Data Lake consulting services 
            streamline strategic planning and data lake deployment, enhancing 
            agility and efficiency throughout the process.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 14%" },
    },
    {
      title: "Insights from Latest Tools",
      text: `Position your business for data-driven triumphs. Our service equips you 
            with advanced analytics and insights, vital for informed, impactful 
            decisions that shape your industry trajectory.`,
      padding: { xs: "2% 8%", md: "2% 11% 3% 21%" },
    },
  ].map((item, index) => (
    <Paper
      key={index}
      elevation={3}
      sx={{
        width: { xs: "90%", md: "370px" },
        height: { xs: "auto", md: "260px" },
        padding: "16px",
        textAlign: "center",
        boxShadow: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Typography
        sx={{
          fontFamily: "Inter",
          lineHeight: "120%",
          fontSize: { xs: "18px", md: "20px" },
          fontWeight: "bold",
          color: "#000",
          letterSpacing: "2%",
          display: "flex",
          alignItems: "center",
          gap: "8px",
        }}
      >
        <img
          src="/assets/BigData/DataLake/charm_circle-tick.png"
          alt="icon"
          style={{
            width: "24px",
            height: "24px",
            verticalAlign: "middle",
          }}
        />
        {item.title}
      </Typography>
      <Typography
        sx={{
          fontFamily: "Inter",
          fontSize: { xs: "14px", md: "16px" },
          lineHeight: "140%",
          textAlign: {xs:"center",md:"left"},
          padding: item.padding,
          color: "#555",
        }}
      >
        {item.text}
      </Typography>
    </Paper>
  ))}
</Box>

    </Box>
  );
};

export default DataLake;
